import _ from 'lodash';
import dayjs from 'dayjs';
import CausesForm from './CausesForm';
import { connect } from 'react-redux';
import { decode as base64_decode } from 'base-64';
import FileBase64 from '../../../Utils/FileUpload';
import { constant } from '../../../Utils/constants';
import { PaperClipOutlined } from '@ant-design/icons';
import { StyledSubHeading } from '../../../CSS/style';
import React, { useEffect, useRef, useState } from 'react';
import translation from '../../../../../commons/translation';
import InputComponent from '../../../Widgets/InputComponent';
import localStorage from '../../../../../utils/localStorage';

import { API_MASTERFAILURECODES } from '../../../../../commons/api';
import { QuestionCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import {
  Form,
  message,
  Select,
  Collapse,
  Popconfirm,
  Divider,
  Space,
  Tooltip,
  Modal,
  Button
} from 'antd';
import {
  getProblemCodesList,
  getSitesList,
  submitMasterFailureCode,
  insertModalData,
  getMasterById
} from '../../../Utils/FormCalls';

const { Option } = Select;
const { Panel } = Collapse;
const type = 'FailureCode';
const ActionType = 'create';
const urlList = {
  insert: API_MASTERFAILURECODES.INSERT,
  getbyId: API_MASTERFAILURECODES.GetById
};
const modalInsertUrl = {
  ProblemMaster: 'Problem_Codes',
  CauseMaster: 'Cause_Codes',
  RemedyMaster: 'Remedy_Codes'
};

const FailureCodeDetails = (props) => {
  const [ProblemCodes, setProblemCodes] = useState([]);
  const [CausesList] = useState([]);
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const [sitesList, setSitesList] = useState([]);
  const [visible, setVisible] = useState(false);
  // const [visibleRemedy, setVisibleRemedy] = useState(false);
  // const [visibleCause, setVisibleCause] = useState(false);
  const [formObjectProblem] = useState({});
  // const [formObjectCause, setFormObjectCause] = useState({});
  // const [formObjectRemedy, setFormObjectRemedy] = useState({});
  const failureCodeAttachment = useState(true);
  const [formObject, setFormObject] = useState(
    props.formObject && Object.keys(props.formObject).length > 0 ? props.formObject : {}
  );

  const FailureCodeRef = useRef();
  const RemedyModalRef = useRef();
  const CauseModalRef = useRef();
  const ProblemModalRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      FailureCodeRef.current.resetFields();
      await _getDataById();
      try {
        const sitesList = await getSitesList();
        const ProblemCodes = await getProblemCodesList();
        let formObject = FailureCodeRef.current.getFieldsValue();
        formObject = {
          ...formObject,
          SiteId: localStorage.get('currentSite') ? parseInt(localStorage.get('currentSite')) : ''
        };
        FailureCodeRef.current.setFieldsValue(formObject);
        setSitesList(sitesList);
        setFormObject(formObject);
        setProblemCodes(ProblemCodes);
      } catch (error) {
        // message.warning(`${error.message}`);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
    if (
      props.formObject &&
      Object.keys(props.formObject).length === 0 &&
      Object.keys(formObject).length === 0
    ) {
      onReset();
    }
    if (props.formObject && Object.keys(props.formObject).length === 0) {
      if (FailureCodeRef.current) FailureCodeRef.current.setFieldsValue(props.formObject);
    }
    if (props.formObject !== formObject) {
      setFormObject(props.formObject);
    }
  }, [props]);

  const openModal = async () => {
    let formObject = FailureCodeRef.current.getFieldsValue();
    setVisible(true);
    setFormObject(formObject);
  };

  const _getDataById = async () => {
    let formObject = {};
    if (props.EWOModal === true) {
      if (FailureCodeRef.current) {
        FailureCodeRef.current.setFieldsValue(formObject);
      }
      setFormObject(formObject);
    } else {
      let path = props.location.pathname.split('/rubus/AMM/FailureCodeDetails/');
      let formId = base64_decode(path[1]);
      if (formId !== 'new') {
        let data = await getMasterById(urlList.getbyId, base64_decode(path[1]), 'GET');
        formObject = data && data !== undefined ? data : {};
        _.cloneDeepWith(data, (value) => {
          return value && value !== null && value.StartTime && value.EndTime
            ? {
              ...value,
              ...(value['StartTime'] = dayjs.utc(value.StartTime, 'YYYY-MM-DD HH:mm:ss')),
              ...(value['EndTime'] = dayjs.utc(value.EndTime, 'YYYY-MM-DD HH:mm:ss'))
            }
            : _.noop();
        });
      }
      if (FailureCodeRef.current) {
        FailureCodeRef.current.setFieldsValue(formObject);
      }
      setFormObject(formObject);
    }
  };

  const onFormsubmit = async (values) => {
    let { fileData } = formObject;
    let payload = {
      ...formObject,
      ...values
    };
    let statusResponse = await submitMasterFailureCode(urlList.insert, payload, fileData, type);
    if (statusResponse && statusResponse.message) {
      if (props.EWOModal === true) {
        props.onFCModalSubmit(payload);
      }
      _getDataById();
      message.success(statusResponse.message);
      onReset();
      if (!props.EWOModal) {
        props.navigate('/rubus/AMM/FailureCodeList');
      }
    } else if (statusResponse && statusResponse.Error) {
      message.error(statusResponse.Error);
    }
  };

  const handleChange = async (value, key, ArrayKey) => {
    const curretFormObject = FailureCodeRef.current.getFieldsValue();
    if (!ProblemCodes || ProblemCodes.length === 0) {
      console.error("ProblemCodes is not defined or empty");
      return;
    }
    const selectedDevice = ProblemCodes.find((item) => item.Id === value);
    if (key === 'Problem' && selectedDevice) {
      const updatedProblems = curretFormObject[ArrayKey].map(item => {
        if (item.ProblemId === value) {
          return {
            ...item,
            Description: selectedDevice.Description
          };
        }
        return item;
      });
      curretFormObject[ArrayKey] = updatedProblems;
    } if (FailureCodeRef.current) {
      FailureCodeRef.current.setFieldsValue(curretFormObject);
    }
    setFormObject(curretFormObject);
  };

  const handleSelect = (value, mainkey, problemIndex, subkey, causeIndex, selectedObject) => {
    // Get the current form values
    let formObject = FailureCodeRef.current.getFieldValue();

    // Access the Causes array from the form object
    let Causes = formObject?.[mainkey];

    // Update the specific cause's Description and Remarks
    Causes?.forEach((item, index) => {
      if (index === problemIndex && item && item[subkey] && item[subkey][causeIndex]) {
        item[subkey][causeIndex]['Description'] = selectedObject[0]['Description'];
        item[subkey][causeIndex]['Remarks'] = selectedObject[0]['Remarks'];
      }
    });

    // Set the updated form values
    if (FailureCodeRef.current) {
      FailureCodeRef.current.setFieldsValue(formObject);
    }

    // Update the state with the new form object
    setFormObject(formObject);
  };

  const onReset = () => {
    if (FailureCodeRef.current) FailureCodeRef.current.resetFields();
    if (ProblemModalRef.current) ProblemModalRef.current.resetFields();
    if (CauseModalRef.current) CauseModalRef.current.resetFields();
    if (RemedyModalRef.current) RemedyModalRef.current.resetFields();
  };

  const onCancel = (e) => {
    if (e.target.tagName === 'DIV') {
      e.preventDefault();
      message.error('Please Click On Cancel');
    } else {
      setVisible(false);
    }
  };
  const RemediehandleSelect = (
    value,
    mainkey,
    problemIndex,
    subkey,
    causeIndex,
    subsubkey,
    remedyIndex,
    selectedObject
  ) => {
    // Get the current form values
    let formObject = FailureCodeRef.current.getFieldValue();
    let TaskData = formObject?.[mainkey];

    // Update the specific remedy's Description and Remarks
    TaskData?.forEach((item, index) => {
      if (index === problemIndex) {
        item[subkey][causeIndex][subsubkey][remedyIndex]['Description'] =
          selectedObject[0]['Description'];
        item[subkey][causeIndex][subsubkey][remedyIndex]['Remarks'] = selectedObject[0]['Remarks'];
      }
    });

    // Set the updated form values
    if (FailureCodeRef.current) {
      FailureCodeRef.current.setFieldsValue(formObject);
    }

    // Update the state with the new form object
    setFormObject(formObject);
  };

  const fileupload = async (values, key) => {
    // Get the current form values
    let formObject = FailureCodeRef.current.getFieldsValue();

    // Initialize the key in formObject if it doesn't exist
    formObject[key] = formObject[key] || [];

    // Push new values into the existing array
    formObject[key].push(...values);

    // Remove duplicates based on the 'Name' property
    formObject[key] = formObject[key].reduce((acc, current) => {
      const x = acc.find((item) => item.Name === current.Name);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);

    // Update the form values
    if (FailureCodeRef.current) {
      FailureCodeRef.current.setFieldsValue({
        ...formObject,
        [key]: formObject[key]
      });
    }

    // Update the state with the new form object
    setFormObject(formObject);
  };

  const onModalFormsubmit = async (e) => {

    e.preventDefault();
    ProblemModalRef.current
      .validateFields()
      .then(async (values) => {
        let payload = {
          ...values
        };
        let response = await insertModalData(modalInsertUrl.ProblemMaster, ActionType, payload);
        if (response && response.message) {
          message.success(response.message);
          onReset();
          // Fetch updated problem codes
          let ProblemCodes = await getProblemCodesList();
          setProblemCodes(ProblemCodes); // Update the state with new problem codes
          setVisible(false);
        } else if (response && response.Error) {
          message.error(response.Error);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const removeCause = (problemIndex, causeIndex, key) => {
    // Get the current form values
    let formObject = FailureCodeRef.current.getFieldsValue();

    // Check if the Problems array and the specific problem exist
    let ToolsList = formObject?.Problems?.[problemIndex];

    if (ToolsList && ToolsList[key]) {
      // Filter out the cause that needs to be removed
      let Causes = ToolsList[key].filter((_, index) => causeIndex !== index);

      // Update the formObject with the new Causes array
      formObject = {
        ...formObject,
        Problems: formObject.Problems.map((problem, index) => {
          if (index === problemIndex) {
            let CauseArray = problem[key] || [];
            Causes = CauseArray.filter((_, cIndex) => cIndex !== causeIndex);
            return { ...problem, [key]: Causes }; // Update the specific key with the new Causes
          }
          return problem; // Return the unchanged problem
        })
      };

      // Set the updated form values
      if (FailureCodeRef.current) {
        FailureCodeRef.current.setFieldsValue(formObject);
      }

      // Update the state with the new form object
      setFormObject(formObject);
    }
  };

  return (
    <>
      <Form
        name="Item"
        ref={FailureCodeRef}
        initialValues={formObject}
        onFinish={onFormsubmit}
        onKeyDown={(e) => {
          e.key === 'Enter' && e.preventDefault();
        }}
        layout="horizontal"
        labelCol={{ flex: '130px' }}
        labelAlign="right"
        labelWrap
        validateMessages={{
          required: '${label} is required!',
          types: {
            email: '${label} is not a valid email!',
            number: '${label} is not a valid number!'
          },
          number: {
            range: '${label} must be between ${min} and ${max}'
          }
        }}>
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Form.Item>
            <Button htmlType="submit">
              {translation(translationCache, constant.submit)}
            </Button>
          </Form.Item>
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <Form.Item name="Id"></Form.Item>
          <Form.Item
            style={{ width: '100%', flex: '50%' }}
            label={translation(translationCache, constant.failureClass)}
            name="FailureCode"
            rules={[{ required: true }]}>
            <InputComponent
              disabled={formObject && formObject.Id ? true : false}
              style={{ width: '70%' }}
              placeholder={translation(translationCache, 'Input FailureClass')}
            />
          </Form.Item>
          <Form.Item
            style={{ width: '100%', flex: '50%' }}
            label={translation(translationCache, constant.failureClassDescription)}
            name="Description"
            rules={[{ required: true }]}>
            <InputComponent
              style={{ width: '70%' }}
              placeholder={translation(translationCache, 'Input Failure Class Description')}
            />
          </Form.Item>
          <Form.Item
            style={{ width: '100%', flex: '50%' }}
            label={translation(translationCache, constant.site)}
            name="SiteId"
            disabled={formObject && formObject.Id ? true : false}
            rules={[{ required: true }]}>
            <Select
              style={{ width: '70%' }}
              placeholder={translation(translationCache, 'Select Site')}
              disabled={formObject && formObject.Id ? true : false}
              onChange={(e) => handleChange(e, 'SiteId')}>
              {sitesList &&
                Array.isArray(sitesList) &&
                sitesList.map((site, index) => (
                  <Option key={index} value={site.Id}>
                    {site.Name}
                  </Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item
            style={{ width: '100%', flex: '50%' }}
            name="Attachments"
            label={
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>
                  {translation(translationCache, constant.attachments)}
                  <PaperClipOutlined className="plusCircleOutlined" />
                </span>
              </div>
            }>
            <FileBase64
              style={{ width: '70%' }}
              failureCodeAttachment={failureCodeAttachment}
              downloadClassName={'formdownloadInput'}
              Attachments={formObject?.Attachments || []}
              fileUpload={fileupload}
            />
          </Form.Item>
          <Form.Item name="key" />
        </div>
        <StyledSubHeading>{translation(translationCache, constant.problems)}</StyledSubHeading>
        <Form.List name="Problems">
          {(fields, { add, remove }) => (
            <>
              <div style={{ display: 'flex', justifyContent: 'right' }}>
                <Form.Item>
                  <Button onClick={() => add()}>
                    {translation(translationCache, constant.addProblem)}
                  </Button>
                </Form.Item>
              </div>
              {fields && Array.isArray(fields) && fields.length > 0 ? (
                <Collapse accordion defaultActiveKey={[]}>
                  {fields.map((field, index) => (
                    <Panel
                      key={`${translation(translationCache, constant.problem)} ${index + 1}`}
                      header={`${translation(translationCache, constant.problem)} ${index + 1}`}
                      extra={
                        <Popconfirm
                          title={translation(
                            translationCache,
                            'Are you sure that you want to delete the Problem'
                          )}
                          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                          onConfirm={() => remove(field.name)}
                          okText={translation(translationCache, constant.yes)}
                          cancelText={translation(translationCache, constant.no)}>
                          <Tooltip
                            title={translation(translationCache, 'Delete')}
                            placement="bottom">
                            <DeleteOutlined />
                          </Tooltip>
                        </Popconfirm>
                      }>
                      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <Form.Item
                          style={{ width: '100%', flex: '50%' }}
                          label={translation(translationCache, constant.problemCode)}
                          name={[field.name, 'ProblemId']}
                          rules={[{ required: true }]}>
                          <Select
                            style={{ width: '70%' }}
                            placeholder={translation(translationCache, 'Select Problem')}
                            dropdownRender={(menu) => (
                              <>
                                {menu}
                                <Divider style={{ margin: '8px 0' }} />
                                <Space style={{ padding: '0 8px 4px' }}>
                                  <Button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      openModal();
                                      if (ProblemModalRef.current)
                                        ProblemModalRef.current.resetFields();
                                    }}>
                                    {translation(translationCache, constant.addProblem)}
                                  </Button>
                                </Space>
                              </>
                            )}
                            onChange={(value) =>
                              handleChange(value, 'Problem', 'Problems', field.key)
                            }>
                            {ProblemCodes &&
                              Array.isArray(ProblemCodes) &&
                              ProblemCodes.map((item, index) => (
                                <Option
                                  key={index}
                                  value={item.Id}
                                  disabled={
                                    FailureCodeRef.current &&
                                      FailureCodeRef.current.getFieldsValue() &&
                                      FailureCodeRef.current.getFieldsValue().Problems &&
                                      FailureCodeRef.current
                                        .getFieldsValue()
                                        .Problems.filter(
                                          (failure) => failure && failure.ProblemId === item.Id
                                        ).length > 0
                                      ? true
                                      : false
                                  }>
                                  {item.ProblemCode}
                                </Option>
                              ))}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          style={{ width: '100%', flex: '50%' }}
                          label={translation(translationCache, 'Description')}
                          name={[field.name, 'Description']}
                          rules={[{ required: false }]}>
                          <InputComponent
                            placeholder={translation(
                              translationCache,
                              'Autopopulate based on Problem'
                            )}
                            style={{ width: '70%' }}
                            disabled
                          />
                        </Form.Item>
                        <Form.Item
                          style={{ width: '100%', flex: '50%' }}
                          {...field}
                          label={translation(translationCache, constant.remarks)}
                          name={[field.name, 'Remarks']}>
                          <InputComponent
                            placeholder={translation(translationCache, 'Input Remarks')}
                            style={{ width: '32%' }}
                          />
                        </Form.Item>
                      </div>
                      <Form.Item>
                        <CausesForm
                          onRemove={removeCause}
                          formObject={FailureCodeRef.current.getFieldsValue()}
                          fieldKey={field.name}
                          onCauseChange={handleSelect}
                          onRemedieSelect={RemediehandleSelect}
                          // onCauseModalOpen={openCause}
                          // onRemedyModalOpen={openRemedy}
                          CausesList={CausesList}
                        />
                      </Form.Item>
                    </Panel>
                  ))}
                </Collapse>
              ) : null}
            </>
          )}
        </Form.List>
      </Form>
      <Modal
        width={800}
        closable
        title={translation(translationCache, constant.newProblemCode)}
        open={visible}
        onCancel={onCancel}
        footer={[
          <Button danger key="2" onClick={onCancel}>
            Cancel
          </Button>,
          <Button key="1" onClick={onModalFormsubmit}>
            Submit
          </Button>
        ]}>
        <Form
          ref={ProblemModalRef}
          onFinish={onModalFormsubmit}
          initialValues={formObjectProblem}
          layout="vertical"
          labelAlign="right"
          labelWrap>
          <Form.Item
            style={{ width: '100%', flex: '50%' }}
            label={translation(translationCache, constant.newProblemCode)}
            name="ProblemCode"
            rules={[{ required: true }]}>
            <InputComponent
              placeholder={translation(translationCache, 'Input NewProblemCode')}
              style={{ width: '70%' }}
            />
          </Form.Item>
          <Form.Item
            style={{ width: '100%', flex: '50%' }}
            label={translation(translationCache, constant.description)}
            name="Description"
            rules={[{ required: true }]}>
            <InputComponent
              placeholder={translation(translationCache, 'Input Description')}
              style={{ width: '70%' }}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache
  };
};

export default connect(mapStateToProps)(FailureCodeDetails);
